$(document).ready(function () {
  
// featured collection slider start
var swiper = new Swiper(".featured_collection_slider", {
  spaceBetween: 0,
  followFinger: true,
  pagination: {
    el: ".swiper-pagination",
    clickable: true,
  },
   navigation: {
    nextEl: ".featured_slider-next",
    prevEl: ".featured_slider-prev",
  },
  mousewheel: {
    releaseOnEdges: true,
  },

  breakpoints: {
    320: {
      slidesPerView: 1,
    },
    500: {
      slidesPerView: 2,
    },
    1025: {
      slidesPerView: 3,
    },
  },
});

  
// blog slider start
// var swiper = new Swiper(".blog_slider", {
//   spaceBetween: 30,
//   pagination: {
//     el: ".swiper-pagination",
//     clickable: true,
//   },
//    navigation: {
//     nextEl: ".blog_slider-next",
//     prevEl: ".blog_slider-prev",
//   },
//   mousewheel: {
//     releaseOnEdges: true,
//   },
//   breakpoints: {
//     320: {
//       slidesPerView: 1,
//       spaceBetween: 0,
//     },
//     500: {
//       slidesPerView: 2,
//     },
//     1025: {
//       slidesPerView: 3,
//     },
//   },
// });

// testimonial slider start
var swiper = new Swiper(".cstm_swiper", {
  spaceBetween: 30,
  pagination: {
    el: ".swiper-pagination",
    clickable: true,
  },
   navigation: {
    nextEl: ".testimonial_slider-next",
    prevEl: ".testimonial_slider-prev",
  },
  mousewheel: {
    releaseOnEdges: true,
  },
  breakpoints: {
    320: {
      slidesPerView: 1,
      spaceBetween: 20,
    },
    500: {
      slidesPerView: 2,
      spaceBetween: 20,
    },
    1025: {
      slidesPerView: 3,
      spaceBetween: 30,
    },
  },
});


// product page description accordion
document.querySelectorAll('.accordion').forEach((accordion) => {
    accordion.addEventListener('click', function() {
        // Close all accordions first
        document.querySelectorAll('.accordion').forEach((item) => {
            if (item !== this) {
                item.classList.remove('active');
                item.nextElementSibling.classList.remove('open');
            }
        });
        
        // Toggle the clicked accordion
        this.classList.toggle('active');
        const content = this.nextElementSibling;
        content.classList.toggle('open');
    });
});


// subscription js start
  setTimeout (function() {
        $(document).find('.easyoptionlabel').removeClass('ItgActive');
        $(document).find('input[type="radio"]:checked').parents('.easyoptionlabel').addClass('ItgActive');

        $('.itg_subscription_plane').find('input[type="radio"]').trigger('click');
        
  },100);


  $(document).on("click", ".easyoptionlabel", function() {
    setTimeout (function() {
        $(document).find('.easyoptionlabel').removeClass('ItgActive');
        $(document).find('input[type="radio"]:checked').parents('.easyoptionlabel').addClass('ItgActive');
    },100);
    
   var slected_value = $('.easyoptionlabel input[type="radio"]:checked').attr('data-purchase');
    if(slected_value == 'subscribe'){
      $('.product_subscription_display').addClass('active');
      $('.itg_subscription_delivery').addClass('active');
      $('.checked_input:first-child input[type="radio"]').prop('checked', true);
      var selectedval = $('.itg_subscription_delivery.active select').children("option:selected").attr('data-sellingval');
      $('.selling_value').val(selectedval);

      var dis = $(document).find('.itg_subscription_price span').text();
      dis = dis.replace("USD", "");
      dis = dis.replace("$", "");
       var temp = dis * 1;
      $(document).find('.prod_points').text(temp);
      
    }else{
      $('.itg_subscription_delivery').removeClass('active');
      $('.product_subscription_display').removeClass('active');
      $('.selling_value').val();
      $(".checked_input input[type='radio']").prop('checked', false);

      var dis_2 = $(document).find('.itg_subscription_price').attr('data-price');
      var temp_2 = Number(dis_2 * 1);
      $(document).find('.prod_points').text(temp_2);
      
    }

    
    $(".itg_subscription_delivery.active select").change(function(){
        var selectedval = $(this).children("option:selected").attr('data-sellingval');
        $('.selling_value').val(selectedval);
    });
   
  });


$(document).on('change', '.itg_subscription_delivery.active select', function () {
     setTimeout (function () {
        var dis_3 = $(document).find('.itg_subscription_price span').text();
        console.log(dis_3)
        dis_3 = dis_3.replace("USD", "");
        dis_3 = dis_3.replace("$", "");
      
        var temp_3 = dis_3 * 1;
        $(document).find('.prod_points').text(temp_3);
     }, 500);
});


  
  
$(window).on('load', function() {
  SwymGrCheckSelling();
  SwymGrCheckDiscount();
});

$(document).on('change', '.itg_ctm_subscription [name="selling_plan"], .itg_subscription_delivery.active select', function () {
  SwymGrCheckSelling();  
});


const SwymGrCheckSelling = () => {
  setTimeout (function () {
    if  ($(document).find('.product-single__meta .itg_ctm_subscription .itg_subscription_plane.easyoptionlabel.ItgActive').length) {
       var sellingID = $(document).find('.itg_subscription_plane.easyoptionlabel.ItgActive .itg_subscription_delivery.active select').val();
        var sellingsId = '<input type="hidden" name="selling_plan" value="'+sellingID+'">';
        // var discountLineItem = '<input id="Subscription" type="hidden" name="properties[Subscription]" value="Yes">';
        if ($(document).find('.payment-buttons .quantityForm').find('[name="selling_plan"]').length) {
          $(document).find('.payment-buttons .quantityForm').find('[name="selling_plan"]').remove();
           // $(document).find('.payment-buttons .quantityForm').find('#Subscription').remove();
        }
        $(document).find('.payment-buttons .quantityForm').append(sellingsId);
        // $(document).find('.payment-buttons .quantityForm').append(discountLineItem);

     
    } else {
        if ($(document).find('.payment-buttons .quantityForm').find('[name="selling_plan"]').length) {
          $(document).find('.payment-buttons .quantityForm').find('[name="selling_plan"]').remove();
           // $(document).find('.payment-buttons .quantityForm').find('#Subscription').remove();
        }
      
    }
  }, 500);
}

const SwymGrCheckDiscount = () => {
  if ($(document).find('.SwymGrDiscountMultiple').length) {
    $.ajax({
      url: "/cart.json",
      dataType: "json",
      success: function(cartData) {
        var uniqueDiscountBundles = new Set();
      }
    });
  }
}


// subscription js end


$(document).on('change', '.itg_ctm_subscription .itg_subscription_plane .itg_subscription_delivery select', function () {
    var discountPer = $(this).find('option:selected').attr('data-discount') / 100;

    var productPrice = $(this).find('option:selected').attr('data-price');
    productPrice = parseFloat(productPrice);

    let savePrice = productPrice - discountPer;
    let price = productPrice - savePrice;
    setTimeout(function name(params) {
      $(document).find('.itg_ctm_subscription .itg_subscription_price del').text('$' + productPrice.toFixed(2) + " USD");
      $(document).find('.itg_ctm_subscription .itg_subscription_price span').text('$' + price.toFixed(2) + " USD");
      $(document).find('.itg_ctm_subscription .itg_subscription_plane label span').text('$' + discountPer.toFixed(2));;
    }, 100)
    
});




  const anchor = document.getElementById('order_history');
if (anchor) {
    anchor.addEventListener('click', function(event) {
      event.preventDefault();
      const target = anchor.getAttribute('href').substring(1);
      smoothScroll(target);
    });
}


  function smoothScroll(target) {
  const element = document.getElementById(target);
  if (element) {
    window.scrollTo({
      top: element.offsetTop,
      behavior: 'smooth'
    });
  }
}

document.addEventListener("smile-ui-loaded", () => {
  // SmileUI has loaded
  Smile.fetchCustomer({ include: "vip_tier" }).then((customer) => {

  console.log(customer);
  
  // Set referral URL

  if (document.querySelector(".clipBoardInput"))  
  document.querySelector('.clipBoardInput').value = customer.referral_url;
  
  if (customer.vip_tier) {
    const vipTierName = customer.vip_tier.name || customer.vip_tier.label;
    const points = customer.points_balance;
  
    console.log(vipTierName + '--');
  
    // Set VIP badge name
    document.querySelector('.badgeName').textContent = vipTierName;
  
    if (vipTierName === 'Bronze') {
      var customer_points = points;
      document.querySelector('.customer_price').textContent = (625 - customer_points) + " points";
      document.querySelector('.customer_bronze').textContent = 'Silver';
      document.querySelector('.badge').textContent = 'Silver';
    }
    else if (vipTierName === 'Silver') {
      var customer_points = points - 625;
      document.querySelector('.customer_price').textContent = (1500 - customer_points) + " points";
      document.querySelector('.customer_bronze').textContent = 'Gold';
      document.querySelector('.badge').textContent = 'Gold';
    }
    else if (vipTierName === 'Gold') {
      document.querySelector('.tierStatus').innerHTML = '';
      document.querySelector('.referalText').innerHTML = '';
      document.querySelector('.badge').textContent = 'Gold';
    }
  }
  
  // For follow section
  if (customer) {
    document.querySelector('.icon_text.accout').classList.add('active');
  }
  if (customer.date_of_birth) {
    document.querySelector('.icon_text.birthday').classList.add('active');
  }
      
    
  });
});

// for scroll section 
$('#order_history').click(function() {
  $('html, body').animate({
    scrollTop: $('.account_detail #order_history').offset().top - 150 
  }, 10); // Adjust 1000 to control scroll speed in milliseconds
});

$('#refer_btn').click(function() {
  $('html, body').animate({
    scrollTop: $('#refer_section').offset().top - 150 
  }, 10); // Adjust 1000 to control scroll speed in milliseconds
});

$('.buttonDiv .btnFst').click(function() {
  $('html, body').animate({
    scrollTop: $('.featured-collection').offset().top - 150 
  }, 10); // Adjust 1000 to control scroll speed in milliseconds
});


  $('.customBanner .copy_to_clipboard_btn').click(copyToClipboard);

   function copyToClipboard() { 
      // Select the input element
      const input = document.getElementById("linkInput");
      
      // Select the text inside the input field
      input.select();
      input.setSelectionRange(0, 99999); // For mobile devices
      
      // Copy the text to the clipboard
      navigator.clipboard.writeText(input.value)
          .then(() => {
              // alert("Link copied to clipboard!");
          })
          .catch(err => {
              console.error("Failed to copy: ", err);
          });
    }


  

  document.addEventListener("DOMContentLoaded", function () {
    // Select the iframe element
    const iframe = document.querySelector('iframe'); // Update with your iframe selector if needed

    // Ensure the iframe exists and is loaded
    if (iframe) {
        iframe.onload = function () {
            try {
                // Access the iframe's document
                const iframeDoc = iframe.contentDocument || iframe.contentWindow.document;

                // Select the target div inside the iframe
                const targetDiv = iframeDoc.querySelector('.home-view-container');

                if (targetDiv) {
                    // Create the new content to append
                    const newContent = iframeDoc.createElement('div');
                    newContent.className = 'custom-content';
                    newContent.innerHTML = `
                        <p>Welcome to Smile.io! Here’s some custom content just for you.</p>
                    `;
                    newContent.style.padding = '10px';
                    newContent.style.backgroundColor = '#f0f8ff';
                    newContent.style.border = '1px solid #ddd';

                    // Append the content to the target div
                    targetDiv.appendChild(newContent);
                } else {
                    console.error('Target div with class "home-view-container" not found in the iframe.');
                }
            } catch (error) {
                console.error('Error accessing iframe content:', error);
            }
        };
    } else {
        console.error('Iframe not found.');
    }
});
 
 
 // One Time Purchase Popup JS Start
document.body.addEventListener('click', function (event) {
  const oneTimePurchasePopup = document.querySelector('.itg_one_time_purchase');
  if (!oneTimePurchasePopup) return; // Ensure the element exists
 
  if (!event.target.closest('.itg_one_time_purchase') && !event.target.closest('.one_time_col')) {
    oneTimePurchasePopup.style.display = 'none';
    document.body.classList.remove('itg_active_purchase');
  }
});
 
document.querySelector('.one_time_col')?.addEventListener('click', function () {
  const oneTimePurchasePopup = document.querySelector('.itg_one_time_purchase');
  oneTimePurchasePopup.style.display = 'block';
  document.body.classList.add('itg_active_purchase');
});

document.querySelector('.itg_onetime_close')?.addEventListener('click', function () {
  const oneTimePurchasePopup = document.querySelector('.itg_one_time_purchase');
  oneTimePurchasePopup.style.display = 'none';
  document.body.classList.remove('itg_active_purchase');
});

 // One Time Purchase Popup JS End


  
});







